(function(){
	$(document).ready(function() {
		var currentTable = "";
		var searchInTable = "";
		/**
		 * Function to validate form data
		 */
		function validate(element) {
			var preventSubmit = true;
			var type = $(element).attr("type");
			switch (type) {
				case 'email':
					var emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
					if (!emailRegex.test($(element).val())) {
						preventSubmit = true;
					} else {
						preventSubmit = false;
					}
					break;
				case 'radio':
				case 'checkbox':
					if (!element.checked) {
						preventSubmit = true;
					} else {
						preventSubmit = false;
					}
					break;
				case 'file':
					var nameFile = $(element).attr("data-file");
					var fileBase64 = "[data-file-base64='"+nameFile+"']";
					if ($(fileBase64).val() === "") {
						preventSubmit = true;
					} else {
						preventSubmit = false;
					}
					break;
				default:
					if ($(element).val() === "") {
						preventSubmit = true;
					} else {
						preventSubmit = false;
					}
					break;
			}
			return preventSubmit;
		}

		/**
		 * Function notification
		 */
		var timerNotification = null;
		function showNotification(statusNotification, message) {
			$("[data-notification]").addClass("notification--show");
			$("[data-notification]").attr("data-notification", statusNotification);
			$("[data-notification-message]").text(message);
			timerNotification = setTimeout(function(){
				$("[data-notification]").removeClass("notification--show");
				$("[data-notification-message]").text("");
				$("[data-notification]").attr("data-notification", "");
				clearTimeout(timerNotification);
			}, 5000);
		}
		/**
		 * Function to open / close the menu
		 */
		$(document).on("click", "[data-toggle-menu]", function(e) {
			e.preventDefault();
			// Get menu
			var menu = $(this).attr("data-toggle-menu");
			// Toggle class
			$("[data-menu='"+menu+"']").toggleClass("menu--open");
			$("[data-content='"+menu+"']").toggleClass("content--small");
		});

		/**
		 * Function to open / close lists
		 */
		$(document).on("click", "[data-toggle-list]", function(e) {
			e.preventDefault();
			// Get list
			var list = $(this).attr("data-toggle-list");
			// Toggle class
			$("[data-list]").not("[data-list='"+list+"']").removeClass("header__list--show");
			$("[data-list='"+list+"']").toggleClass("header__list--show");
		});

		/**
		 * Function to close list
		 */
		$(document).on("click", "[data-mask]", function(e) {
			e.preventDefault();
			// Remove class
			$("[data-list]").removeClass("header__list--show");
		});

		/**
		 * Function to change theme
		 */
		$(document).on("click", "[data-change-theme]", function(e) {
			// Get theme
			var theme = $(this).val();
			// Set theme in body
			$("body").attr("class", theme);
		});

		/**
		 * Function to close notification
		 */
		$(document).on("click", "[data-notification]", function(e) {
			e.preventDefault();
			// Remove class
			$(this).removeClass("notification--show");
			clearTimeout(timerNotification);
		});

		/**
		 * Function to get data of form
		 */
		function callForm(formName, element, effect, text) {
			// Get form
			var form = document.querySelector("[data-form='"+formName+"']");
			// Validate form data
			var preventSubmitt = false;
			$(form).find('input[required], select[required], textarea[required]').not("[type='hidden']").each(function(event) {
				if(validate(this)) {
					preventSubmitt = true;
				}
			});
			if(!preventSubmitt) {
				// Get data form
				var data = $(form).serialize();
				// Get method
				var method = $(form).attr("method");
				// Get url
				var url = $(form).attr("action");
				$.ajax({
					url: url,
					type: method,
					data: data,
					beforeSend: function() {
						showWaiteMe(element, effect, text);
					},
					success: function(response) {
						hideWaitMe("body");
						showNotification(response.status_notification, response.message);

						if(response.reload && response.success) {
							setTimeout(function(){
								location.reload();
							}, 1000);
						}
						if(response.redirect && response.success) {
							setTimeout(function(){
								location.href = response.url;
							}, 1000);
						}
						if(response.new_tab && response.success) {
							setTimeout(function(){
								window.open(response.url, '_blank');
								location.reload();
							}, 1000);
						}
						if(response.hasOwnProperty('action') && response.action) {
							if(response.action === 'update_table') {
								$("[data-table-refresh='"+currentTable+"']").click();
								form.reset();
							}
							if(response.action === 'delete_stored_data') {
								window.forceDeleteLocalStorageVariable([response.stored_data])
							}
						}
						$("[data-close-popup]").click();
					},
					error: function(error) {
						hideWaitMe("body");
						if(error.status === 429) {
							showNotification('error', 'Demasiados intentos, espera un minuto.');
						}
						// console.log(error);
					}
				});
			}
			else {
				showNotification("error", "Por favor verifique los datos.");
			}
		}

		$(document).on('keypress', '[data-form]', function(e) {
			if (e.which === 13) { // Enter key
				if (e.target.tagName.toLowerCase() === 'textarea') {
					return; // no hacemos preventDefault
				}
				e.preventDefault(); // Stop form submit
			}
		});

		/**
		 * Function to input radio / checkbox call form
		 */
		$(document).on("click", "input[type='radio'][data-call-form], input[type='checkbox'][data-call-form]", function(e) {
			// Get form name
			var formName = $(this).attr("data-call-form");
			// Call function form
			callForm(formName, "body", "facebook", "Procesando... por favor espere");
		});
		/**
		 * Function to input text, email, number, tel
		 */
		$(document).on("change", "input[type='text'][data-call-form], input[type='email'][data-call-form], input[type='number'][data-call-form], input[type='tel'][data-call-form]", function(e) {
			// Get form name
			var formName = $(this).attr("data-call-form");
			// Call function form
			callForm(formName, "body", "facebook", "Procesando... por favor espere");
		});

		/**
		 * Function to input call form
		 */
		$(document).on("click", "button[data-call-form]", function(e) {
			e.preventDefault();
			// Get form name
			var formName = $(this).attr("data-call-form");
			// Get elements for waitMe
			var effect = ($(this).attr("data-effect-form")) ? $(this).attr("data-effect-form") : "facebook";
			var message = ($(this).attr("data-message-form")) ? $(this).attr("data-message-form") : "Procesando... por favor espere";
			// Call function form
			callForm(formName, "body", effect, message);
		});

		/**
		 * Function to add template js
		 */
		$(document).on("click", "[data-template-add]", function(e) {
			e.preventDefault();
			var templateName = $(this).attr("data-template-add");
			var template = $("[data-template-type='" + templateName + "']");
			var containerTemplate = $("[data-container-template='" + templateName + "']");
			var nextIndex = containerTemplate.find("[data-template-index]").length ? parseInt(containerTemplate.find("[data-template-index]").last().attr("data-template-index")) + 1 : 0;
			var item = $("<div>").html(template.html());
			item.find("[data-template-index]").attr("data-template-index", nextIndex);
			item.find("[data-index-delete]").attr("data-index-delete", nextIndex);
			containerTemplate.append(item.children());
			containerTemplate.parents("form").find("[data-call-form]").prop("disabled", false);
		});

		$(document).on("click", "[data-template-delete]", function(e) {
			e.preventDefault();
			var btn = $(this);
			var templateName = btn.attr("data-template-delete");
			var index = btn.attr("data-index-delete");
			var form = btn.parents("form");
			var template = form.find("[data-container-template='"+templateName+"']");
			template.find("[data-template-index='"+index+"']").remove();
			var newIndex = 0;
			var rows = template.find("[data-template-index]");
			var blockBtnCallForm = (form.attr("data-block-disabled") && form.attr("data-block-disabled") === 'false') ? false : true;
			if(!rows.length && blockBtnCallForm) {
				form.find("[data-call-form]").prop("disabled", true);
			}
			rows.each(function() {
				var item = $(this);
				item.attr("data-template-index", newIndex).find("[data-index-delete]").attr("data-index-delete", newIndex);
				item.find("[data-counter-pieces]").text(newIndex + 1)
				newIndex = newIndex + 1;
			});
			if(window.searchType === 'entradas') {
				saveData('entradas', $("[data-form='add-entrada']"));
			}
			if(window.searchType === 'salidas') {
				saveData('salidas', $("[data-form='add-salida']"));
			}
			if(window.searchType === 'sale') {
				calculateTotal(template);
			}
		});

		/**
		 * Function to create the html of a multiselect (same as components/globals/multiselect.blade.php)
		 */
		function renderMultiselect(name, options, selected, placeholder) {
			var html = '<div class="cform__multiselect" data-multiselect data-placeholder="'+escapeText(placeholder)+'">';
			html += '<button type="button" class="cform__multiselectfield" data-multiselect-toggle><i class="bi bi-chevron-down cform__multiselectarrow"></i></button>';
			html += '<div class="cform__multiselectpanel">';
			html += '<div class="cform__multiselectsearch">';
			html += '<i class="bi bi-search"></i>';
			html += '<input type="text" placeholder="Buscar..." data-multiselect-search>';
			html += '</div>';
			html += '<div class="cform__multiselectlist">';
			for(var key in options) {
				html += '<label class="cform__multiselectoption">';
				html += '<input type="checkbox" name="'+name+'" value="'+escapeText(options[key])+'"'+((selected && selected.indexOf(options[key]) >= 0) ? ' checked' : '')+'>';
				html += '<span class="cform__multiselectcheck"><i class="bi bi-check2"></i></span>';
				html += '<span class="cform__multiselecttext">'+escapeText(options[key])+'</span>';
				html += '</label>';
			}
			html += '<div class="cform__multiselectempty">Sin resultados</div>';
			html += '</div>';
			html += '<div class="cform__multiselectfooter">';
			html += '<span data-multiselect-count></span>';
			html += '<button type="button" data-multiselect-clear>Limpiar</button>';
			html += '</div>';
			html += '</div>';
			html += '</div>';
			return html;
		}

		/**
		 * Function to show the selected options as tags and the counter of a multiselect
		 */
		function updateMultiselect(multiselect) {
			var maxTags = 4;
			var inputs = multiselect.find("input[type='checkbox']");
			var selected = inputs.filter(":checked");
			var html = '';
			if(!selected.length) {
				html += '<span class="cform__multiselectplaceholder">'+escapeText(multiselect.attr("data-placeholder"))+'</span>';
			}
			selected.each(function(index) {
				if(index < maxTags) {
					html += '<span class="cform__multiselecttag">'+escapeText($(this).val())+'<i class="bi bi-x-lg" data-multiselect-remove="'+escapeText($(this).val())+'"></i></span>';
				}
			});
			if(selected.length > maxTags) {
				html += '<span class="cform__multiselectmore">+'+(selected.length - maxTags)+' más</span>';
			}
			html += '<i class="bi bi-chevron-down cform__multiselectarrow"></i>';
			multiselect.find("[data-multiselect-toggle]").html(html);
			multiselect.find("[data-multiselect-count]").text(selected.length+' de '+inputs.length+' seleccionados');
		}

		/**
		 * Function to open / close a multiselect
		 */
		$(document).on("click", "[data-multiselect-toggle]", function(e) {
			e.preventDefault();
			var multiselect = $(this).closest("[data-multiselect]");
			var isOpen = multiselect.hasClass("cform__multiselect--open");
			$("[data-multiselect]").removeClass("cform__multiselect--open");
			if(!isOpen) {
				multiselect.addClass("cform__multiselect--open");
				multiselect.find("[data-multiselect-search]").focus();
			}
		});

		/**
		 * Function to close the multiselect when click outside or press Esc
		 */
		$(document).on("click", function(e) {
			if(!$(e.target).closest("[data-multiselect]").length) {
				$("[data-multiselect]").removeClass("cform__multiselect--open");
			}
		});
		$(document).on("keydown", function(e) {
			if(e.key === "Escape") {
				$("[data-multiselect]").removeClass("cform__multiselect--open");
			}
		});

		/**
		 * Function to update the multiselect when an option is checked / unchecked
		 */
		$(document).on("change", "[data-multiselect] input[type='checkbox']", function(e) {
			updateMultiselect($(this).closest("[data-multiselect]"));
		});

		/**
		 * Function to remove an option from its tag
		 */
		$(document).on("click", "[data-multiselect-remove]", function(e) {
			e.preventDefault();
			e.stopPropagation();
			var value = $(this).attr("data-multiselect-remove");
			var multiselect = $(this).closest("[data-multiselect]");
			multiselect.find("input[type='checkbox']").filter(function() {
				return $(this).val() === value;
			}).prop("checked", false).trigger("change");
		});

		/**
		 * Function to clear all options of a multiselect
		 */
		$(document).on("click", "[data-multiselect-clear]", function(e) {
			e.preventDefault();
			$(this).closest("[data-multiselect]").find("input[type='checkbox']").prop("checked", false).trigger("change");
		});

		/**
		 * Function to search options of a multiselect
		 */
		$(document).on("input", "[data-multiselect-search]", function(e) {
			var multiselect = $(this).closest("[data-multiselect]");
			var text = $(this).val().trim().toLowerCase();
			var visible = 0;
			multiselect.find(".cform__multiselectoption").each(function() {
				var match = $(this).text().toLowerCase().indexOf(text) >= 0;
				$(this).toggleClass("cform__multiselectoption--hidden", !match);
				if(match) {
					visible = visible + 1;
				}
			});
			multiselect.find(".cform__multiselectempty").toggleClass("cform__multiselectempty--show", visible === 0);
		});

		/**
		 * Function to update the multiselects after form.reset()
		 */
		$(document).on("reset", "[data-form]", function(e) {
			var form = $(this);
			setTimeout(function() {
				form.find("[data-multiselect-search]").val('').trigger("input");
				form.find("[data-multiselect]").each(function() {
					updateMultiselect($(this));
				});
			}, 0);
		});

		/**
		 * Quick search of modules and actions (Ctrl + K)
		 */
		var quickResults = [];
		var quickActive = 0;

		/**
		 * Function to get a text in lowercase without accents ("Configuración" -> "configuracion")
		 */
		function normalizeText(text) {
			return (text ?? "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
		}

		/**
		 * Function to filter the options of the quick search (the ones that start with the text go first)
		 */
		function searchQuickItems(text) {
			var popup = $("[data-popup='quick-search']");
			var items = JSON.parse(popup.attr("data-quick-search-items") || "[]");
			var query = normalizeText(text.trim());
			quickResults = items.filter(function(item) {
				return !query || normalizeText(item.label+" "+item.keywords+" "+item.group).indexOf(query) >= 0;
			});
			if(query) {
				quickResults.sort(function(a, b) {
					return (normalizeText(a.label).indexOf(query) === 0 ? 0 : 1) - (normalizeText(b.label).indexOf(query) === 0 ? 0 : 1);
				});
			}
			quickActive = 0;
			renderQuickResults(text, query);
		}

		/**
		 * Function to show the results of the quick search
		 */
		function renderQuickResults(text, query) {
			var html = '';
			var group = '';
			if(!quickResults.length) {
				html = '<div class="qsearch__empty">No hay módulos que coincidan con "'+escapeText(text.trim())+'"</div>';
			}
			quickResults.forEach(function(item, index) {
				if(!query && item.group !== group) {
					group = item.group;
					html += '<div class="qsearch__group">'+escapeText(group)+'</div>';
				}
				// Highlight the text found in the name
				var label = escapeText(item.label);
				var position = (query) ? normalizeText(item.label).indexOf(query) : -1;
				if(position >= 0) {
					label = escapeText(item.label.slice(0, position))+'<mark>'+escapeText(item.label.slice(position, position + query.length))+'</mark>'+escapeText(item.label.slice(position + query.length));
				}
				html += '<a href="'+escapeText(item.url)+'" class="qsearch__item'+((index === quickActive) ? ' qsearch__item--active' : '')+'" data-quick-search-item="'+index+'">';
				html += '<i class="'+escapeText(item.icon)+'"></i><span>'+label+'</span>';
				if(query) {
					html += '<small>'+escapeText(item.group)+'</small>';
				}
				html += '</a>';
			});
			$("[data-quick-search-list]").html(html);
		}

		/**
		 * Function to select a result of the quick search (cyclic)
		 */
		function setQuickActive(index) {
			if(!quickResults.length) {
				return;
			}
			quickActive = (index + quickResults.length) % quickResults.length;
			var list = $("[data-quick-search-list]");
			list.find("[data-quick-search-item]").removeClass("qsearch__item--active");
			var item = list.find("[data-quick-search-item='"+quickActive+"']").addClass("qsearch__item--active");
			item[0].scrollIntoView({ block: "nearest" });
		}

		/**
		 * Function to open / close the quick search (same as the popups of startedpack)
		 */
		function openQuickSearch() {
			var popup = $("[data-popup='quick-search']");
			if(!popup.length) {
				return;
			}
			popup.addClass("sctpopup--opened").animate({ opacity: 1 }, 200);
			popup.find("[data-quick-search-input]").val("").trigger("focus");
			searchQuickItems("");
		}
		function closeQuickSearch() {
			var popup = $("[data-popup='quick-search']");
			popup.animate({ opacity: 0 }, 200, function() {
				popup.removeClass("sctpopup--opened").removeAttr("style");
			});
		}

		// Ctrl + K (⌘ + K on Mac): open the quick search from any page
		$(document).on("keydown", function(e) {
			if((e.ctrlKey || e.metaKey) && e.code === "KeyK") {
				e.preventDefault();
				openQuickSearch();
			}
		});
		$(document).on("click", "[data-open-quick-search]", function(e) {
			e.preventDefault();
			openQuickSearch();
		});
		$(document).on("click", "[data-close-quick-search]", function(e) {
			e.preventDefault();
			closeQuickSearch();
		});
		$(document).on("input", "[data-quick-search-input]", function(e) {
			searchQuickItems($(this).val());
		});
		// Keys of the field (stopPropagation: e.g. Esc must not clear the sale of hotkeys.js)
		$(document).on("keydown", "[data-quick-search-input]", function(e) {
			if((e.ctrlKey || e.metaKey) && e.code === "KeyK") {
				return;
			}
			e.stopPropagation();
			if(e.code === "ArrowDown") {
				e.preventDefault();
				setQuickActive(quickActive + 1);
			}
			if(e.code === "ArrowUp") {
				e.preventDefault();
				setQuickActive(quickActive - 1);
			}
			if(e.code === "Enter" || e.code === "NumpadEnter") {
				e.preventDefault();
				if(quickResults[quickActive]) {
					location.href = quickResults[quickActive].url;
				}
			}
			if(e.code === "Escape") {
				e.preventDefault();
				closeQuickSearch();
			}
		});
		$(document).on("mousemove", "[data-quick-search-item]", function(e) {
			var index = parseInt($(this).attr("data-quick-search-item"));
			if(index !== quickActive) {
				setQuickActive(index);
			}
		});
		// Mac: ⌘ K
		if(/Mac|iPhone|iPad/.test(navigator.platform)) {
			$("[data-quick-search-keys]").text("⌘ K");
		}

		/**
		 * Function to show the fade at the side of the quick access that has hidden items
		 */
		function updateQuickAccessEdges() {
			$("[data-quickaccess]").each(function() {
				var quickaccess = $(this);
				var list = quickaccess.find("[data-quickaccess-list]")[0];
				quickaccess.toggleClass("quickaccess--left", list.scrollLeft > 1);
				quickaccess.toggleClass("quickaccess--right", list.scrollLeft + list.clientWidth < list.scrollWidth - 1);
			});
		}
		$("[data-quickaccess-list]").on("scroll", updateQuickAccessEdges);
		$(window).on("resize", updateQuickAccessEdges);

		/**
		 * Function to scroll the quick access horizontally with the mouse wheel (only when it has hidden items)
		 * Bound to the list, not delegated: the wheel listeners of the document are passive and can not preventDefault
		 */
		$("[data-quickaccess-list]").on("wheel", function(e) {
			var list = this;
			var deltaY = e.originalEvent.deltaY;
			if(list.scrollWidth <= list.clientWidth || Math.abs(e.originalEvent.deltaX) > Math.abs(deltaY)) {
				return;
			}
			e.preventDefault();
			list.scrollLeft += deltaY;
		});

		/**
		 * Function to get size in Bytes, KB, MB, GB, TB
		 */
		function bytesToSize(bytes) {
			var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
			if(bytes === 0) {
				return '0 Bytes'
			}
			var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
			return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
		}

		/**
		 * Function to convert file in base64
		 */
		function convertBase64(file, nameFile) {
			var fr = new FileReader();
			showWaiteMe("body", "facebook", "Procesando archivo... por favor espere");
			fr.onload = function(e) {
				var srcFile = e.target.result;
				$("[data-file-base64='"+nameFile+"']").val(srcFile);
				hideWaitMe("body");
			}
			fr.readAsDataURL(file);
		}

		/**
		 * Function to convert file in base64
		 */
		$(document).on("change", "[data-file]", function(e) {
			var inputFile = this;
			var file = inputFile.files;
			var nameFile = $(inputFile).attr("data-file");
			if(file.length) {
				file = file[0];
				var name = file.name;
				var ext = name.split('.').pop();
				var size = bytesToSize(file.size);
				name = name + ' ' + size;
				$("[data-info-file='"+nameFile+"']").addClass("cform__filetext--hidden");
				$("[data-name-file='"+nameFile+"']").text(name).removeClass("cform__filetext--hidden");
				$("[data-file-name-base64='"+nameFile+"']").val(ext);
				$("[data-delete-file='"+nameFile+"']").removeClass("cform__filedelete--hidden");
				$(inputFile).css({visibility: 'hidden'}); 
				convertBase64(file, nameFile);
			}
		});

		/**
		 * Function to clear a selection of 
		 */
		$(document).on("click", "[data-delete-file]", function(e) {
			e.preventDefault();
			var nameFile = $(this).attr("data-delete-file");
			$("[data-info-file='"+nameFile+"']").removeClass("cform__filetext--hidden");
			$("[data-name-file='"+nameFile+"']").text("").addClass("cform__filetext--hidden");
			$("[data-file-name-base64='"+nameFile+"']").val("");
			$(this).addClass("cform__filedelete--hidden");
			$("[data-file-base64='"+nameFile+"']").val("");
			$("[data-file='"+nameFile+"']").val("").removeAttr("style");
		});

		/**
		 * Function to call delete
		 */
		$(document).on("click", "[data-delete]", function(e) {
			e.preventDefault();
			var href = $(this).attr('href');
			Swal.fire({
				title: '¿Seguro que quieres eliminarlo?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Si',
				cancelButtonText: 'No',
			}).then(function(result) {
				 if(result.isConfirmed) {
				 	location.href = href;
				 }
			});
		});

		/**
		 * Function to search with typing
		 */
		var searchResults;
		var searchLength = 0;
		var cform;
		var cformParentElement;
		var cformList;
		var cformIndex;
		$(document).on("keyup", "[data-search]", function(e) {
			e.preventDefault();
			var searchElement = $(this);
			var searchType = searchElement.attr('data-search');
			cform = searchElement.parents("form");
			cformParentElement = searchElement.parents("[data-template-index]");
			cformIndex = cformParentElement.attr("data-template-index");
			var searchWord = searchElement.val();
			var rex = new RegExp(searchWord.normalize("NFD").replace(/[\u0300-\u036f]/g, ""), 'i');
			cformList = searchElement.siblings("ul.cform__list");
			if(searchWord.length === searchLength) {}
			else if(searchWord.length === 0 || searchWord.length === 1) {
				cformList.empty();
			}
			else {
				var grepLimiter = 0;
				var result = $.grep(window.products, function(value) {
					if(grepLimiter > 10) {
						return false;
					}
					else {
						if(rex.test(value.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")) || (value.codebar && rex.test(value.codebar.normalize("NFD").replace(/[\u0300-\u036f]/g, "")))) {
							grepLimiter++;
							return true;
						}
					}
				});
				cformList.empty();
				result.forEach(function(value, index) {
					cformList.append("<li data-select-item='"+index+"' data-object='"+JSON.stringify(value)+"'>"+value.name+"</li>");
				});
				if(result.length === 1 && searchWord.length >= 10) {
					setTimeout(function() {
						cformList.find("li").first().click();
					}, 200);
					// cform.find("[data-template-add]").click();
				}
			}
			searchLength = $(this).val().length;
		});

		/**
		 * Function to add element of list search
		 */
		$(document).on("click", "[data-select-item]", function(e) {
			e.preventDefault();
			var item = $(this);
			var object = JSON.parse(item.attr("data-object"));
			if(object.stock <= 0 && window.searchType !== "entradas") {
				window.showSwal({
					icon: "warning",
					title: "Sin piezas disponibles"
				}, function() {
					cformList.empty();
					$("[data-search='search']").val('').trigger('keyup').focus();
				})
				return;
			}
			var template = $("[data-template-name='newline']");
			var containerTemplate = $("[data-container-template='newline']");
			var currentIndex = containerTemplate.find("[data-template-index]").length;
			var htmlTemplate = template.html();
			var ifExists = (containerTemplate.find("[data-product-id='"+object.id+"']") && containerTemplate.find("[data-product-id='"+object.id+"']").length) ? true : false;
			if(!ifExists) {
				containerTemplate.append(htmlTemplate);
				containerTemplate.find("[data-template-index]").last().attr("data-template-index", currentIndex).attr("data-product-id", object.id).find("[data-index-delete]").attr("data-index-delete", currentIndex);
				for(var key in object) {
					var keySearch = key;
					if(key === 'name') keySearch = 'product';
					if(key === 'stock') keySearch = 'pieces';
					if(keySearch === 'pieces') {
						var inputPieces = $("[data-template-index='"+currentIndex+"']").find("[name='pieces[]']");
						inputPieces.val(1);
						if( window.searchType !== 'entradas' ) {
							inputPieces.attr("max", object[key]);
						}
						$("[data-template-index='"+currentIndex+"']").find("[name='subtotal[]']").val(1 * object.price);
					}
					else {
						$("[data-template-index='"+currentIndex+"']").find("[name='"+keySearch+"[]']").val(object[key]);
					}
				}
			}
			else {
				currentIndex = $("[data-product-id='"+object.id+"']").attr("data-template-index");
				var inputPieces = $("[data-product-id='"+object.id+"']").find("[name='pieces[]']");
				var newPieces = parseInt(inputPieces.val()) + 1;
				if(window.searchType !== "entradas") {
					if(newPieces <= object.stock) {
						inputPieces.val(newPieces);
					}
					else {
						window.showSwal({
							icon: "info",
							title: "Solo puedes agregar "+object.stock+" pieza(s)."
						})
						newPieces = object.stock;
					}
				}
				else {
					inputPieces.val(newPieces);
				}
				if($("[data-product-id='"+object.id+"']").find("[name='subtotal[]']").length) {
					$("[data-product-id='"+object.id+"']").find("[name='subtotal[]']").val(newPieces * object.price);
				}
			}
			cformList.empty();
			$("[data-search='search']").val('').trigger('keyup').focus();
			$("[data-template-index='"+currentIndex+"']").find("[data-counter-pieces]").text(currentIndex + 1);
			if(window.searchType === 'sale') {
				calculateTotal($("[data-template-index='"+currentIndex+"']").find("input[name='pieces[]']"));
			}
			if(window.searchType === 'entradas') {
				window.sumEntradas();
				saveData('entradas', $("[data-form='add-entrada']"));
			}
			if(window.searchType === 'salidas') {
				saveData('salidas', $("[data-form='add-salida']"));
			}
			$("[data-call-form]").prop("disabled", false);
			window.scrollToElement("[data-template-index='"+currentIndex+"']");
		});

		/**
		 * Function to prevent more o max
		 */
		$(document).on("change", "input[type='number']", function(e) {
			var value = parseFloat($(this).val());
			var max = ($(this).attr("max")) ? parseFloat($(this).attr("max")) : false;
			if(max) {
				if(value > max) {
					$(this).val(max);
					Swal.fire({
						icon: "warning",
						text: "No puedes colocar más de " + max,
					});
				}
			}
		});

		/**
		 * Save Data
		 */
		function saveData(type, form) {
			var object = {
				data: []
			}
			form.find("[data-template-index]").each(function(e) {
				var el = $(this);
				var index = el.attr("data-template-index");
				var inputs = el.find("input, textarea");
				if (!object.data[index]) {
					object.data[index] = {};
				}
				inputs.each(function(e) {
					var input = $(this);
					var name = input.attr("name").replace("[]", "");
					var value = input.val();
					var max = input.attr("max");
					object.data[index][name] = value;
					if(max) {
						object.data[index]['max'] = max;
					}
				});
			});
			if(type === 'sales') {
				object.discount_type = form.find("[name='discount_type']").val();
				object.discount = form.find("[name='discount']").val();
				object.sub_total = form.find("[name='sub_total']").val();
				object.total = form.find("[name='total']").val();
				object.payment = form.find("[name='payment']").val();
				object.change = form.find("[name='change']").val();
				object.payment_type = form.find("[name='payment_type']").val();
				window.sales = object;
				window.sales.data = window.sales.data.filter(function(item) {
					return item !== null;
				});
			}
			if(type === 'entradas') {
				object.total_cost_buy = form.find("[total-cost-buy]").text();
				object.total_cost_price = form.find("[total-cost-price]").text();
				window.entradas = object;
				window.entradas.data = window.entradas.data.filter(function(item) {
					return item !== null;
				});
			}
			if(type === 'salidas') {
				window.salidas = object;
				window.salidas.data = window.salidas.data.filter(function(item) {
					return item !== null;
				});
			}
			window.persistState(type);
		}

		/**
		 * Function calculaChange
		 */
		function calculateChange(paymentElement, totalElement) {
			if(paymentElement.val()) {
				var payment = parseFloat(paymentElement.val());
				var total = parseFloat(totalElement.val());
				var totalChange = payment - total;
				$("[data-change]").val(totalChange);
			}
			saveData('sales', $("[data-form='add-sale']"));
		}

		/**
		 * Function to multiply cost
		 */
		function calculateTotal(inputElement) {
			var currentForm = inputElement.parents("form");
			var subTotalElement = currentForm.find("[data-total='subtotal']");
			var totalElement = currentForm.find("[data-total='total']");
			var discounTypeElement = currentForm.find("[data-discount-type]");
			var discountQuantityElement = currentForm.find("[data-discount-quantity]");
			var subtotals = currentForm.find("input[name='subtotal[]']");
			var totalPayment = currentForm.find("input[data-payment]");
			var subTotalAll = 0;
			var totalAll = 0;
			subtotals.each(function(e) {
				var auxTotal = parseFloat($(this).val());
				subTotalAll = subTotalAll + auxTotal;
			});
			totalAll = subTotalAll;
			subTotalElement.val(subTotalAll);
			if(discounTypeElement.length && discountQuantityElement.length) {
				var discountType = discounTypeElement.val();
				var discountQuantity = discountQuantityElement.val();
				if(discountType !== "" && discountQuantity !== '') {
					if(discountType === 'porcentaje') {
						discountQuantity = parseFloat(discountQuantity);
						discountQuantity = discountQuantity / 100;
						totalAll = subTotalAll - (subTotalAll * discountQuantity);
						var decimal = parseFloat((totalAll - Math.floor(totalAll)).toFixed(1));
						if(decimal < 0.4) {
							totalAll = Math.floor(totalAll);
						}
						else {
							totalAll = Math.ceil(totalAll);
						}
					}
					if(discountType === 'fijo') {
						discountQuantity = parseFloat(discountQuantity);
						totalAll = subTotalAll - discountQuantity;
					}
				}
			}
			totalElement.val(totalAll);
			calculateChange(totalPayment, totalElement);
		}

		$(document).on("input", "[data-payment]", function(e) {
			var element = $(this);
			var totalElement = $("[data-total='total']");
			calculateChange(element, totalElement);
		});

		$(document).on("change", "[name='payment_type']", function(e) {
			calculateTotal($(this));
		});

		$(document).on("change", "[data-multiply-pieces]", function(e) {
			var inputElement = $(this);
			var templateIndex = inputElement.parents("[data-template-index]");
			var indexElement = templateIndex.attr("data-template-index");
			var costElement = $("[data-template-index='"+indexElement+"']").find("input[name='price[]']");
			var price = parseFloat(costElement.val());
			var pieces = parseFloat(inputElement.val());
			var maxPieces = parseFloat(inputElement.attr("max"));
			var total = price * pieces;
			if(pieces > maxPieces) {
				showNotification("error", "Solo tiene "+maxPieces+" disponibles, verifique la cantidad.");
			}
			$("[data-template-index='"+indexElement+"']").find("input[name='subtotal[]']").val(total);
			calculateTotal(inputElement);
		});

		$(document).on("change", "[data-discount-type]", function(e) {
			calculateTotal($(this));
		});

		$(document).on("keyup", "[data-discount-quantity]", function(e) {
			calculateTotal($(this));
		});

		/**
		 * Convert image to base64
		 */
		function readImage(file, imageElement) {
			var fr = new FileReader();
			fr.onload = function(e) {
				$("img[data-image='"+imageElement+"']").attr("src", e.target.result);
				$("img[data-image='"+imageElement+"']").parents(".photo__container").addClass('block-1-1');
				logoName = file.files[0].name;
				sourceLogo = e.target.result;
			};
			fr.readAsDataURL(file.files[0]);
		}

		/**
		 * Function to upload image
		 */
		$(document).on("change", "[data-image-file]", function(e){
			var file = this;
			var imageContainer = $(this).attr("data-image-file");
			var fileTypes = $(this).attr("accept").replace(/\./gi, "image/").split(", ");
			if(file.files && file.files[0]) {
				if(fileTypes.indexOf(file.files[0].type) >= 0) {
					readImage(this, imageContainer);
				}
				else {
					$("img[data-image='"+imageContainer+"']").attr("src", "");
				}
			}
		});

		/**
		 * Function to show / hide password
		 */
		$(document).on("click", "[data-show-password]", function(e){
			var showPassword = $(this);
			var inputPassword = $("input[name='"+showPassword.attr("data-show-password")+"']");
			if(inputPassword.attr("type") === "password") {
				inputPassword.attr("type", "text");
				showPassword.find("i").removeClass("fa-eye");
				showPassword.find("i").addClass("fa-eye-slash");
			}
			else {
				inputPassword.attr("type", "password");
				showPassword.find("i").removeClass("fa-eye-slash");
				showPassword.find("i").addClass("fa-eye");
			}
		});

		/**
		 * Enable field
		 */
		$(document).on("change", "[data-enable-field]", function(e) {
			var element = $(this);
			var fieldToEnable = element.attr("data-enable-field");
			var enableIf = element.attr("data-enable-if");
			var value = element.val();
			if(value === enableIf) {
				$("[data-field='"+fieldToEnable+"']").removeAttr("disabled");
				$("[data-fields='"+fieldToEnable+"']").show();
			}
			else {
				$("[data-field='"+fieldToEnable+"']").prop("disabled", true);
				$("[data-fields='"+fieldToEnable+"']").removeAttr('style');
			}
		});

		/**
		 * functions to manage Datatables
		 */
		var aTables = [];
		function initDataTable(table) {
			var indexOrder = 0
			var urlAjax = (table.attr("data-url")) ? table.attr("data-url") : false;
			var order = 'asc';
			var overwriteOptions = (table.attr("data-overwrite-options")) ? JSON.parse(table.attr("data-overwrite-options")) : {};
			table.find(".table__order > th").each(function(){
				if($(this).hasClass("table__orderby")) {
					indexOrder = $(this).index();
					if($(this).attr("data-order")) {
						order = $(this).attr('data-order');
					}
					return false;
				}
			});
			var pageLength = parseInt(user_settings.per_page.value);
			if(overwriteOptions.hasOwnProperty('pageLength')) {
				pageLength = parseInt(overwriteOptions.pageLength);
			}
			var aDatatable = {
				"order": [[indexOrder, order]],
				"language": {
					"sProcessing": "Procesando...",
					"sLengthMenu": "Mostrar _MENU_ registros",
					"sZeroRecords":"No se encontraron resultados",
					"sEmptyTable": "Ningún dato disponible en esta tabla =(",
					"sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
					"sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
					"sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
					"sInfoPostFix": "",
					"sSearch": "Buscar:",
					"sUrl": "",
					"sInfoThousands": ",",
					"sLoadingRecords": "Cargando...",
					"oPaginate": {
						"sFirst": "Primero",
						"sLast": "Último",
						"sNext": "Siguiente",
						"sPrevious": "Anterior"
					},
					"oAria": {
						"sSortAscending": ": Activar para ordenar la columna de manera ascendente",
						"sSortDescending": ": Activar para ordenar la columna de manera descendente"
					},
					"buttons": {
						"copy": "Copiar",
						"colvis": "Visibilidad"
					}
				},
				"search": {
					"search": searchInTable
				},
				"pageLength": pageLength
			}
			if(urlAjax) {
				aDatatable['ajax'] = urlAjax;
			}
			var tableInit = table.DataTable(aDatatable);
			// Update the totals of the table with each response (e.g. products)
			tableInit.on("xhr", function(e, settings, json) {
				if(json && json.totals) {
					for(var key in json.totals) {
						$("[data-table-totals='"+table.attr("data-table")+"'] [data-table-total='"+key+"']").text(json.totals[key]);
					}
				}
				// Count of rows for the summary of filters
				if(json && json.data) {
					$("[data-filters-count='"+table.attr("data-table")+"']").text(json.data.length);
				}
			});
			var iTable = aTables.length ?? 0;
			aTables.push(tableInit);
			table.attr("data-index", iTable);
			if($("[data-request-sales]").length) {
				var elRequestSalesCash = $("[data-request-sales-cash]");
				var elRequestSalesCC = $("[data-request-sales-cc]");
				var elRequestSalesDC = $("[data-request-sales-dc]");
				var elRequestSalesTransfer = $("[data-request-sales-transfer]");
				var elRequestSales = $("[data-request-sales]");
				var indexTotal = table.attr("data-index-total") ?? 0;
				var indexPaymentType = table.attr("data-index-payment-type") ?? 0;
				(async function() {
					var totalCash = 0;
					var totalCC = 0;
					var totalDC = 0;
					var totalTransfer = 0;
					var total = 0;
					var result = await window.ajaxQuery(urlAjax, 'GET', {});
					result.data.forEach(function(value, index) {
						var totalRow = parseFloat(value[indexTotal].replace("$", ""));
						if(value[indexPaymentType] === 'Efectivo') {
							totalCash = totalCash + totalRow;
						}
						if(value[indexPaymentType] === 'Tarjeta de Crédito') {
							totalCC = totalCC + totalRow;
						}
						if(value[indexPaymentType] === 'Tarjeta de Débito') {
							totalDC = totalDC + totalRow;
						}
						if(value[indexPaymentType] === 'Transferencia') {
							totalTransfer = totalTransfer + totalRow;
						}
						total = total + totalRow;
					});
					elRequestSalesCash.text('$'+totalCash.toFixed(2));
					elRequestSalesCC.text('$'+totalCC.toFixed(2));
					elRequestSalesDC.text('$'+totalDC.toFixed(2));
					elRequestSalesTransfer.text('$'+totalTransfer.toFixed(2));
					elRequestSales.text('$'+total.toFixed(2));
				})();
			}
		}

		$(document).on("click", "[data-table-refresh]", function(e) {
			e.preventDefault();
			var btn = $(this);
			var tableName = btn.attr("data-table-refresh");
			currentTable = tableName;
			var table = document.querySelector("[data-table='"+tableName+"']");
			var jTable = $(table);
			var iTable = parseInt(jTable.attr("data-index"));
			var baseUrl = jTable.attr("data-base-url");
			var data = [];
			aTables[iTable].destroy();
			showWaiteMe('body', 'facebook', 'Actualizando...');
			$("[data-change-range='"+tableName+"']").each(function(e) {
				var element = $(this);
				data.push(element.val());
			});
			data = data.join("/");
			// Applied filters of the advanced search
			var filters = (jTable.attr("data-filters")) ? "?"+jTable.attr("data-filters") : "";
			jTable.attr("data-url", baseUrl+"/"+data+filters);
			initDataTable(jTable);
			hideWaitMe('body');
			searchInTable = "";
		});

		/**
		 * Function to show / hide the panel of filters of a table
		 */
		$(document).on("click", "[data-toggle-filters]", function(e) {
			e.preventDefault();
			var tableName = $(this).attr("data-toggle-filters");
			$("[data-filters-panel='"+tableName+"']").toggleClass("wrapper--hidden");
		});

		/**
		 * Function to get the summary of the filters of a form (only the fields with value)
		 */
		function getFiltersSummary(form) {
			var labels = [];
			var groups = {};
			form.find("input[name], select[name]").each(function() {
				var field = $(this);
				var name = field.attr("name");
				if(field.is("select")) {
					if(field.val()) {
						labels.push(field.find("option:selected").text());
					}
				}
				else if(field.is(":checkbox")) {
					if(field.is(":checked")) {
						if(field.closest("[data-multiselect]").length) {
							groups[name] = groups[name] ?? [];
							groups[name].push(field.val());
						}
						else {
							labels.push(field.attr("data-filter-label"));
						}
					}
				}
				else if(field.val().trim() !== "") {
					labels.push(field.attr("data-filter-label")+" "+((field.attr("type") === "text") ? '"'+field.val().trim()+'"' : field.val()));
				}
			});
			for(var key in groups) {
				labels.push(groups[key].join(" o "));
			}
			return labels;
		}

		/**
		 * Function to apply the filters of the advanced search to a table and refresh it
		 */
		function setTableFilters(tableName, filters, summary) {
			var jTable = $("[data-table='"+tableName+"']");
			var summaryElement = $("[data-filters-summary='"+tableName+"']");
			if(filters) {
				jTable.attr("data-filters", filters);
			}
			else {
				jTable.removeAttr("data-filters");
			}
			$("[data-toggle-filters='"+tableName+"'] > i").attr("class", (filters) ? "bi bi-funnel-fill" : "bi bi-funnel");
			summaryElement.find("[data-filters-summary-text]").text(summary.join(" · "));
			summaryElement.toggleClass("message--hidden", !filters);
			$("[data-table-totals='"+tableName+"'] [data-table-totals-label]").text((filters) ? " (filtrado)" : "");
			$("[data-table-refresh='"+tableName+"']").click();
		}

		/**
		 * Function to search with the filters of the advanced search (the panel stays open)
		 */
		$(document).on("submit", "[data-table-filters]", function(e) {
			e.preventDefault();
			var form = $(this);
			var fields = form.serializeArray().filter(function(field) {
				return field.value.trim() !== "";
			});
			setTableFilters(form.attr("data-table-filters"), $.param(fields), getFiltersSummary(form));
		});

		/**
		 * Function to clear the filters of the advanced search
		 */
		$(document).on("click", "[data-table-filters-clear]", function(e) {
			e.preventDefault();
			var tableName = $(this).attr("data-table-filters-clear");
			var form = $("[data-table-filters='"+tableName+"']");
			form[0].reset();
			form.find("[data-multiselect-search]").val('').trigger("input");
			form.find("[data-multiselect]").each(function() {
				updateMultiselect($(this));
			});
			setTableFilters(tableName, "", []);
		});

		/**
		 * Function to manage charts
		 */
		var aCharts = [];
		function initChart(chart) {
			(async function() {
				var jChart = $(chart);
				var type = jChart.attr("data-type") ?? 'bar';
				var title = jChart.attr("data-title") ?? '';
				var url = jChart.attr('data-url');
				var method = jChart.attr("data-method") ?? 'POST';
				var data = {
					'graphic': true,
					'graphicType': 'chartjs',
					'_token': window._token,
				};
				var result = await window.ajaxQuery(url, method, method === 'POST' ? data : {});
				var datasets = result.datasets ?? [{
					label: title,
					data: result.data,
					backgroundColor: result.backgroundColor,
					borderColor: result.borderColor,
					borderWidth: 1
				}];
				var myChart = new Chart(chart, {
					type: type,
					data: {
						labels: result.labels,
						datasets: datasets
					},
					options: {
						plugins: {
							tooltip: {
								callbacks: {
									title: function(items) {
										var dates = items[0].dataset.dates;
										return dates ? dates[items[0].dataIndex] : items[0].label;
									}
								}
							}
						},
						scales: {
							y: {
								beginAtZero: true
							}
						}
					}
				});
				var iChart = aCharts.length ?? 0;
				aCharts.push(myChart);
				jChart.attr("data-index", iChart);
				if( result.resume ) {
					setCompareResume(jChart.attr("data-chart"), result.resume, jChart.attr("data-trend-inverse") !== undefined);
				}
				if( result.summary ) {
					var chartName = jChart.attr("data-chart");
					$("[data-chart-total='"+chartName+"']").text(result.summary.total);
					$("[data-chart-count='"+chartName+"']").text(result.summary.count);
					$("[data-chart-average='"+chartName+"']").text(result.summary.average);
					$("[data-chart-sellers='"+chartName+"']").text(result.summary.sellers);
					$("[data-chart-top='"+chartName+"']").text(result.summary.top);
					if( result.summary.users ) {
						var usersList = '';
						result.summary.users.forEach(function(user) {
							usersList += '<li class="cinfo__item"><strong>'+user.name+':</strong> '+user.total+' · '+user.count+' ventas · '+user.percent+'%</li>';
						});
						if( usersList === '' ) {
							usersList = '<li class="cinfo__item">Sin ventas en el periodo</li>';
						}
						$("[data-chart-users='"+chartName+"']").html(usersList);
					}
				}
			})();
		}
		$(document).on("click", "[data-chart-refresh]", function(e) {
			e.preventDefault();
			var btn = $(this);
			var chartName = btn.attr("data-chart-refresh");
			var chart = document.querySelector("[data-chart='"+chartName+"']");
			var jChart = $(chart);
			var iChart = parseInt(jChart.attr("data-index"));
			var baseUrl = jChart.attr("data-base-url");
			var data = [];
			showWaiteMe(chart.parentNode, 'facebook', 'Actualizando...');
			$("[data-change-range='"+chartName+"']").each(function(e) {
				var element = $(this);
				data.push(element.val());
			});
			data = data.join("/");
			jChart.attr("data-url", baseUrl+"/"+data);
			aCharts[iChart].destroy();
			initChart(chart);
			hideWaitMe(chart.parentNode);
		});
		/**
		 * Function to fill the compare chart resume
		 */
		function setCompareResume(chartName, resume, inverse) {
			$("[data-compare-total-a='"+chartName+"']").text(resume.total_a);
			$("[data-compare-count-a='"+chartName+"']").text(resume.count_a);
			$("[data-compare-total-b='"+chartName+"']").text(resume.total_b);
			$("[data-compare-count-b='"+chartName+"']").text(resume.count_b);
			$("[data-compare-difference='"+chartName+"']").text(resume.difference);
			if( resume.pieces_a !== undefined ) {
				$("[data-compare-pieces-a='"+chartName+"']").text(resume.pieces_a);
				$("[data-compare-pieces-b='"+chartName+"']").text(resume.pieces_b);
			}
			// Salidas going up is bad, use the inverse colors
			var classUp = inverse ? 'up--inverse' : 'up';
			var classDown = inverse ? 'down--inverse' : 'down';
			var trend = $("[data-compare-trend='"+chartName+"']").removeClass([ 'up', 'down', 'up--inverse', 'down--inverse' ]).text('');
			if( resume.difference_trend !== null ) {
				trend.text(resume.difference_trend + '% de A contra B').addClass(resume.difference_trend < 0 ? classDown : classUp);
			}
		}
		$(document).on("change", "[data-chart-type]", function(e) {
			var select = $(this);
			var chartName = select.attr("data-chart-type");
			$("[data-chart='"+chartName+"']").attr("data-type", select.val());
			$("[data-chart-refresh='"+chartName+"']").click();
		});
		/**
		 * Function to init calendar
		 */
		var calendar = null;
		function initCalendar() {
			var calendarEl = document.getElementById('calendar');
			calendar = new FullCalendar.Calendar(calendarEl, {
				timeZone: 'local',
				initialView: 'dayGridMonth',
				nowIndicator: true,
				initialDate: new Date(),
				firstDay: 1,
				events: $(calendarEl).attr("data-url"),
				selectable: true,
				eventDidMount: function(info) {
					if (info.event.extendedProps.description) {
						tippy(info.el, {
							content: info.event.extendedProps.description,
							theme: 'light-border',
							placement: 'top',
						});
					}
				},
				eventClick: function(info) {
					alert(info.event.title + "\n" + info.event.extendedProps.description);
				}
			});
			calendar.render();
		}

		/**
		 * Functions to in init on load
		 */
		function onLoad() {
			if($("[data-table]").length) {
				$("[data-table]").each(function(e) {
					var table = $(this);
					initDataTable(table);
				});
			}
			if($("[data-chart]").length) {
				$("[data-chart]").each(function(e) {
					var chart = this;
					initChart(chart);
				})
			}
			if($("#calendar").length) {
				initCalendar();
			}
			if( $("[data-sale-resume]").length ) {
				$("[data-sale-resume]").click();
			}
			if( $("[data-inventory-resume]").length ) {
				$("[data-inventory-resume]").click();
			}
			if($("[data-multiselect]").length) {
				$("[data-multiselect]").each(function() {
					updateMultiselect($(this));
				});
			}
			if($("[data-quickaccess]").length) {
				updateQuickAccessEdges();
			}
			window.deleteLocalStorageVariable(["sales", "entradas", "salidas"]);
		}
		$(document).on("click", "[data-product-view]", function(e) {
			e.preventDefault();
			var btn = $(this);
			var url = btn.attr("data-product-view");
			var popupName = btn.attr("data-open-popup");
			var popup = $("[data-popup='"+popupName+"']");
			(async function() {
				var info = await window.ajaxQuery(url, 'GET', {});
				popup.find("[data-name]").html(info.product.name);
				popup.find("[data-codebar]").html(info.product.codebar);
				popup.find("[data-price]").html("$"+info.product.price.toFixed(2));
				if(info.product.cost_buy !== undefined) {
					popup.find("[data-costbuy]").html("$"+info.product.cost_buy.toFixed(2));
				}
				popup.find("[data-stock]").html(info.product.stock);
				popup.find("[data-minpieces]").html(info.product.min);
				popup.find("[data-categories]").remove();
				popup.find("[data-providers-title]").remove();
				if(info.product.categories.length) {
					var aCategories = info.product.categories;
					var categories = '<li class="cinfo__item" data-categories><strong>Categorias:</strong> '+info.product.categories.join(", ")+'</li>';
					popup.find("[data-list-info]").append(categories);
				}
				if(info.product.providers && info.product.providers.length && (window.user_type === 'super-admin' || window.user_type === 'admin')) {
					var listProviders = '<li class="cinfo__item" data-providers-title><strong>Proveedores</strong><ul class="cinfo__sublist" data-list-providers></ul></li>';
					popup.find("[data-list-info]").append(listProviders);
					var htmlProviders = '';
					info.product.providers.forEach(function(value, index) {
						htmlProviders += '<li class="cinfo__item"><strong>Proveedor:</strong> '+value+'</li>';
					});
					popup.find("[data-list-providers]").append(htmlProviders);
				}
			})();
		});
		$(document).on("click", "[data-product-edit]", function(e) {
			e.preventDefault();
			var btn = $(this);
			var url = btn.attr("data-product-edit");
			var popupName = btn.attr("data-open-popup");
			currentTable = btn.attr("data-popup-table");
			var popup = $("[data-popup='"+popupName+"']");
			var form = $("[data-form='"+popupName+"']");
			var urlUpdate = form.attr("data-base-url-update");
			form.find("[data-categories]").html('');
			form.find("[data-providers]").html('');
			(async function() {
				var info = await window.ajaxQuery(url, 'GET', {});
				form.find("[data-title]").html(info.product.name);
				form.find('[name="codebar"]').val(info.product.codebar);
				form.find('[name="name"]').val(info.product.name);
				form.find('[name="price"]').val(info.product.price);
				form.find('[name="cost_buy"]').val(info.product.cost_buy);
				form.find('[name="min"]').val(info.product.min);
				form.find('[name="stock"]').val(info.product.stock);
				form.attr("action", urlUpdate+'/'+info.product.id);
				if(info.categories) {
					var categories = '<label for="codebar">Categorias</label>';
					categories += renderMultiselect('categories[]', info.categories, info.product.categories, 'Seleccionar categorías');
					form.find("[data-categories]").append(categories);
				}
				if(info.providers && Object.keys(info.providers).length) {
					var providers = '<label for="codebar">Proveedores</label>';
					providers += renderMultiselect('providers[]', info.providers, info.product.providers, 'Seleccionar proveedores');
					form.find("[data-providers]").append(providers);
				}
				form.find("[data-multiselect]").each(function() {
					updateMultiselect($(this));
				});
			})();
		});
		$(document).on("click", "[data-product-add]", function(e) {
			var btn = $(this);
			currentTable = btn.attr("data-popup-table");
		});
		$(document).on("click", "[data-search]", function(e) {
			e.preventDefault();
			var btn = $(this);
			searchInTable = btn.attr("data-search");
		});
		$(document).on("click", "[data-view]", function(e) {
			e.preventDefault();
			var btn = $(this);
			var url = btn.attr("data-view");
			var name = btn.attr("data-open-popup");
			var form = $("[data-form='"+name+"']");
			(async function() {
				showWaiteMe('body');
				var response = await window.ajaxQuery(url);
				if(response.success) {
					Object.entries(response.data).forEach(function([property, value]) {
						if(!Array.isArray(value)) {
							form.find("[name='"+property+"']").val(value);
						}
						else {
							var container = $("[data-container-template='" + property + "']");
							var templateHtml = $("[data-template-type='" + property + "']").html();
							container.empty();
							value.forEach(function(val, index) {
								var item = $(templateHtml);
								item.attr("data-template-index", index);
								item.find("[name='"+property+"[]']").val(val).prop("readonly", true);
								container.append(item);
							});
						}
					});
				}
				hideWaitMe('body');
			})();
		});
		$(document).on("click", "[data-edit]", function(e) {
			e.preventDefault();
			var btn = $(this);
			var url = btn.attr("data-edit");
			var name = btn.attr("data-open-popup");
			currentTable = btn.attr("data-popup-table");
			var form = $("[data-form='"+name+"']");
			form.attr("action", url);
			url = url.replace('edit', 'view');
			(async function() {
				showWaiteMe('body');
				var response = await window.ajaxQuery(url);
				if(response.success) {
					Object.entries(response.data).forEach(function([property, value]) {
						if(!Array.isArray(value)) {
							form.find("[name='"+property+"']").val(value);
						}
						else {
							var container = $("[data-container-template='"+property+"']");
							var templateHtml = $("[data-template-type='"+property+"']").html();
							container.empty();
							value.forEach(function(val, index) {
								var item = $(templateHtml);
								item.attr("data-template-index", index);
								item.find("[name='"+property+"[]']").val(val);
								container.append(item);
							});
						}
					});
				}
				hideWaitMe('body');
			})();
		});
		$(document).on("click", "[data-call-action]", function(e) {
			e.preventDefault();
			var btn = $(this);
			var object = JSON.parse(btn.attr("data-call-action"));
			window.showSwal({
				title: object.title,
				text: object.message,
				icon: object.icon,
				showCancelButton: true,
				confirmButtonText: 'Si',
				cancelButtonText: 'No',
			}, function(result) {
				(async function() {
					window.showWaiteMe( "body" );
					var method = object.method ?? 'GET';
					var response = await ajaxQuery(object.url, method, method === 'POST' ? { '_token': window._token } : {});
					if(response.success) {
						if(response.action === 'update_table') {
							$("[data-table-refresh='"+response.table+"']").click();
							window.showSwal({
								title: response.title,
								text: response.message
							});
						}
						if(response.action === 'reload') {
							location.reload();
						}
						if(response.action === 'redirect') {
							location.href = response.url;
						}
					}
					else {
						window.showSwal({
							title: "Ocurrio un error",
							text: "Intente más tarde..."
						});
					}
					window.hideWaitMe( "body" );
				})();
			}, function(result) {});
		});
		$(document).on("click", "[data-sale-resume]", function(e) {
			e.preventDefault();
			var btn = $(this);
			var url = btn.attr('href');
			(async function() {
				window.showWaiteMe('[data-resume-item]', 'rotation');
				var response = await ajaxQuery( url );
				$("[data-sale-today]").text(response.sales_today);
				$("[data-sale-today-total]").text(response.sales_today_total);
				$("[data-sale-yesterday]").text(response.sales_yesterday);
				$("[data-sale-yesterday-total]").text(response.sales_yesterday_total);
				$("[data-today-avarage-ticket]").text(response.today_avarage_ticket);
				$("[data-sale-today-cash]").text(response.sales_today_cash);
				$("[data-sale-today-credit]").text(response.sales_today_credit);
				$("[data-sale-today-debit]").text(response.sales_today_debit);
				$("[data-sale-today-transfer]").text(response.sales_today_transfer);
				var classSales = 'up';
				var classTotal = 'up';
				if( response.sales_yesterday_trend < 0 ) {
					classSales = 'down';
				}
				if( response.total_yesterday_trend < 0 ) {
					classTotal = 'down';
				}
				if( response.sales_yesterday_trend ) {
					$("[data-trend-yesterday]").text(response.sales_yesterday_trend + '% vs antier').removeClass([ 'up', 'down' ]).addClass(classSales);
				}
				if( response.total_yesterday_trend ) {
					$("[data-trend-yesterday-total]").text(response.total_yesterday_trend + '% vs antier').removeClass([ 'up', 'down' ]).addClass(classTotal);
				}
				window.hideWaitMe('[data-resume-item]');
			})();
		});
		$(document).on("click", "[data-inventory-resume]", function(e) {
			e.preventDefault();
			var btn = $(this);
			var url = btn.attr('href');
			(async function() {
				window.showWaiteMe('[data-inventory-item]', 'rotation');
				var response = await ajaxQuery( url );
				$("[data-investment-month]").text(response.investment_month);
				$("[data-loss-month]").text(response.loss_month);
				$("[data-loss-percentage]").text(response.loss_percentage !== null ? response.loss_percentage + '%' : '-');
				$("[data-inventory-value]").text(response.inventory_value);
				$("[data-inventory-sale-value]").text(response.inventory_sale_value);
				var trendInvestment = $("[data-trend-investment]").removeClass([ 'up', 'down' ]).text('');
				if( response.investment_month_trend !== null ) {
					trendInvestment.text(response.investment_month_trend + '% vs mes anterior').addClass(response.investment_month_trend < 0 ? 'down' : 'up');
				}
				// Loss going up is bad, use the inverse colors
				var trendLoss = $("[data-trend-loss]").removeClass([ 'up--inverse', 'down--inverse' ]).text('');
				if( response.loss_month_trend !== null ) {
					trendLoss.text(response.loss_month_trend + '% vs mes anterior').addClass(response.loss_month_trend < 0 ? 'down--inverse' : 'up--inverse');
				}
				var pending = $("[data-inventory-pending]");
				if( response.pending_cost_buy > 0 ) {
					pending.text('Hay ' + response.pending_cost_buy + ' entradas/salidas sin costo histórico; los totales pueden ser menores a los reales.').removeClass("message--hidden");
				}
				else {
					pending.addClass("message--hidden");
				}
				window.hideWaitMe('[data-inventory-item]');
			})();
		});
		/**
		 * Function to escape text before adding it as html
		 */
		function escapeText(text) {
			return $('<div>').text(text ?? '').html();
		}
		/**
		 * Advanced search of sales (admin)
		 */
		function searchSales(form, page) {
			var container = "[data-popup='sale-search'] .sctpopup__content";
			(async function() {
				window.showWaiteMe(container, 'rotation');
				var response = await window.ajaxQuery(form.attr('action'), 'GET', form.serialize() + '&page=' + page);
				window.hideWaitMe(container);
				if( ! response.success ) {
					showNotification('error', response.message);
					return;
				}
				$("[data-sale-search-results]").html(renderSearchSales(response.data));
			})();
		}
		function renderSearchSales(data) {
			var html = '<div class="clist__summary">';
			html += '<span>' + data.count + ' ventas · Total: ' + data.total;
			if( data.canceled ) {
				html += ' · ' + data.canceled + ' canceladas';
			}
			html += '</span>';
			if( data.sales.length ) {
				html += '<span class="clist__current">Página ' + data.page + ' de ' + data.pages + ' · ' + data.from + ' a ' + data.to + '</span>';
			}
			html += '</div>';
			if( ! data.sales.length ) {
				return html + '<p>Ninguna venta coincide con los filtros.</p>';
			}
			data.sales.forEach(function(sale) {
				html += '<article class="clist__item' + ( sale.canceled ? ' clist__item--canceled' : '' ) + '">';
				html += '<div class="clist__header">';
				html += '<strong class="clist__invoice">' + sale.invoice + '</strong>';
				html += '<span class="clist__meta">' + sale.date + '</span>';
				html += '<span class="clist__meta">' + escapeText(sale.user) + '</span>';
				html += '<span class="clist__badge">' + sale.payment_type + '</span>';
				if( sale.canceled ) {
					html += '<span class="clist__badge clist__badge--canceled">Cancelada</span>';
				}
				html += '</div>';
				html += '<div class="clist__body">';
				html += '<ul class="clist__products">';
				sale.products.forEach(function(product) {
					html += '<li class="clist__product"><span>' + escapeText(product.pieces) + ' × ' + escapeText(product.description) + '</span><span>' + product.subtotal + '</span></li>';
				});
				html += '</ul>';
				html += '<div class="clist__resume">';
				html += '<span class="clist__label">Total</span>';
				html += '<span class="clist__total">' + sale.total + '</span>';
				if( sale.discount ) {
					html += '<span class="clist__label">Descuento: ' + sale.discount + '</span>';
				}
				if( sale.ticket_url ) {
					html += '<a href="' + sale.ticket_url + '" class="cbutton cbutton--small cbutton--success" target="_blank" title="Ver ticket"><i class="bi bi-receipt-cutoff"></i></a>';
				}
				html += '</div>';
				html += '</div>';
				html += '</article>';
			});
			if( data.pages > 1 ) {
				var start = Math.max(1, data.page - 2);
				var end = Math.min(data.pages, data.page + 2);
				html += '<div class="clist__pages">';
				if( data.page > 1 ) {
					html += '<button type="button" class="cbutton cbutton--small" data-sale-search-page="1" title="Primera">«</button>';
					html += '<button type="button" class="cbutton cbutton--small" data-sale-search-page="' + ( data.page - 1 ) + '" title="Anterior">‹</button>';
				}
				for( var i = start; i <= end; i++ ) {
					html += '<button type="button" class="cbutton cbutton--small' + ( i === data.page ? ' clist__page--current' : '' ) + '" data-sale-search-page="' + i + '">' + i + '</button>';
				}
				if( data.page < data.pages ) {
					html += '<button type="button" class="cbutton cbutton--small" data-sale-search-page="' + ( data.page + 1 ) + '" title="Siguiente">›</button>';
					html += '<button type="button" class="cbutton cbutton--small" data-sale-search-page="' + data.pages + '" title="Última">»</button>';
				}
				html += '</div>';
			}
			return html;
		}
		$(document).on("submit", "[data-sale-search]", function(e) {
			e.preventDefault();
			searchSales($(this), 1);
		});
		$(document).on("click", "[data-sale-search-page]", function(e) {
			e.preventDefault();
			searchSales($("[data-sale-search]"), $(this).attr("data-sale-search-page"));
		});
		$(document).on("click", "[data-sale-search-clear]", function(e) {
			e.preventDefault();
			$("[data-sale-search]")[0].reset();
			$("[data-sale-search-results]").empty();
		});
		onLoad();
	});
})(jQuery);